<template>
  <div
      class="fixed inset-0 z-50 flex flex-col items-center justify-center px-6 text-center backdrop-blur-sm bg-opacity-70"
      :class="[backgroundAuraClass || 'bg-black']"
  >
    <div class="max-w-lg p-8 rounded-lg bg-gray-900 shadow-xl">
      <p class="mb-6 text-xl text-white">{{ prompt }}</p>

      <div class="mb-4">
        <input
          v-if="expectedKind === 'email' || expectedKind === 'phone' || expectedKind === 'free'"
          v-model="answer"
          :type="inputType"
          :placeholder="placeholder"
          class="w-full p-3 bg-gray-800 border border-gray-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          @keyup.enter="submitAnswer"
        />

        <textarea
          v-else
          v-model="answer"
          :placeholder="placeholder"
          class="w-full p-3 bg-gray-800 border border-gray-700 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          rows="3"
          @keyup.enter="submitAnswer"
        ></textarea>
      </div>

      <button
        @click="submitAnswer"
        class="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  prompt: {
    type: String,
    default: 'Share your thoughts...'
  },
  expectedKind: {
    type: String,
    default: 'free' // 'free', 'email', 'phone'
  },
  placeholder: {
    type: String,
    default: 'Type your response...'
  },
  backgroundAuraClass: {
    type: String,
    default: 'aura-violet-glow'
  },
})

const emit = defineEmits(['answered'])

const answer = ref('')

const inputType = computed(() => {
  switch (props.expectedKind) {
    case 'email':
      return 'email'
    case 'phone':
      return 'tel'
    default:
      return 'text'
  }
})

function submitAnswer() {
  if (!answer.value.trim()) return

  emit('answered', answer.value)
  answer.value = ''
}
</script>
